import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MANIFESTO } from "../data";
import { SectionLabel } from "./Reveal";

const IMG = "/methode-dak.webp";

export const Method = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="methode"
      ref={ref}
      className="relative overflow-hidden bg-navy-deep grain py-24 sm:py-32"
      data-testid="method"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionLabel>De Softwash methode</SectionLabel>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.02]">
              Zacht voor de ondergrond, effectief tegen vervuiling
            </h2>
            <p className="mt-6 max-w-md text-white/60 leading-relaxed">
              Softwash verwijdert algen, mos, schimmel en groene aanslag met
              lage druk en een zorgvuldig afgestemde reinigingsoplossing. Zo
              reinigen we daken, gevels en buitenoppervlakken zonder onnodig
              zware waterdruk.
            </p>
            <motion.div
              style={{ y }}
              className="mt-10 overflow-hidden rounded-3xl border border-white/10"
            >
              <img
                src={IMG}
                alt="Voor en na dakreiniging met de Softwash-methode"
                className="h-64 w-full object-cover sm:h-80"
              />
            </motion.div>
          </div>

          <div className="flex flex-col">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                data-testid={`manifesto-${i}`}
                className="border-t border-white/10 py-10 lg:py-14"
              >
                <span className="font-display text-6xl sm:text-7xl font-bold text-white/10">
                  {m.n}
                </span>
                <h3 className="mt-4 font-display text-2xl sm:text-3xl font-bold text-white tracking-tight">
                  {m.title}
                </h3>
                <p className="mt-4 max-w-md text-white/60 leading-relaxed">
                  {m.text}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Method;
